import firebase from '../../Firebase/FirebaseInit'
export default {
  state: {
    user: null,
    currProj: null
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setProj (state, payload) {
      state.currProj = payload
    },
    setURL (state, payload) {
      state.user.photoURL = payload
    }
  },
  actions: {
    editProfile ({dispatch, commit}, {user, file}) {
      commit('setLoading', true)
      commit('clearError')
      if (file != null) {
        let path = 'profile_photos/' + user.id
        var storageref = firebase.storage().ref(path)
        storageref.put(file).then((response) => {
          storageref.getDownloadURL().then(function (url) {
            user.photoURL = url
            dispatch('updateUser1', user)
          }).catch(function (error) {
            console.log(error)
            return
          })
        })
      } else {
        dispatch('updateUser1', user)
      }
    },
    Project ({commit, state}, payload) {
      state.currProj = payload
    },
    addProject ({commit}, {user, id}) {
      firebase.firestore().collection('users').doc(user).collection('projects').add({projectID: id})
      this.currProj = id
    },
    updateUser1 ({commit}, payload) {
      firebase.firestore()
      .collection('users')
      .doc(payload.id)
      .set({id: payload.id, name: payload.name, email: payload.email, photoURL: payload.photoURL, bio: payload.bio, title: payload.title, organization: payload.organization})
      .then((response) => {
        commit('setUser', payload)
        commit('setLoading', false)
      })
    },
    updateUser ({commit}, payload) {
      firebase.firestore()
      .collection('users')
      .doc(payload.id)
      .set({id: payload.id, name: payload.name, projects: payload.projects, email: payload.email, photoURL: payload.photoURL, bio: payload.bio, title: payload.title, organization: payload.organization})
      .then((response) => {
        commit('setUser', payload)
        commit('setLoading', false)
      })
    },
    sendNotification ({commit}, payload) {
      firebase.firestore()
      .collection('users')
      .doc(payload.receiverID)
      .collection('notifications')
      .add({
        message: payload.message,
        senderID: payload.senderID,
        senderName: payload.senderName,
        receiverID: payload.receiverID,
        receiverName: payload.receiverName,
        read: payload.read,
        accepted: payload.accepted,
        timestamp: payload.timestamp,
        type: payload.type
      })
    },
    readNotification ({commit}, {user, notification}) {
      firebase
      .firestore()
      .collection('users')
      .doc(user)
      .collection('notifications')
      .doc(notification)
      .update({
        'read': true
      })
    },
    updateNotification ({commit}, payload) {
      firebase.firestore()
      .collection('users')
      .doc(payload.receiverID)
      .collection('notifications')
      .doc(payload.id)
      .set({
        message: payload.message,
        senderID: payload.senderID,
        senderName: payload.senderName,
        receiverID: payload.receiverID,
        receiverName: payload.receiverName,
        read: payload.read,
        accepted: payload.accepted,
        timestamp: payload.timestamp,
        type: payload.type
      })
    },
    addContact ({commit, state}, {payload, userID}) {
      firebase.firestore()
      .collection('users')
      .doc(userID)
      .collection('contacts')
      .doc(payload.contactID)
      .set({
        contactID: payload.contactID,
        contactName: payload.contactName,
        accepted: payload.accepted,
        timestamp: payload.timestamp
      })
    },
    deleteContact ({commit}, {account, contact}) {
      firebase.firestore()
      .collection('users')
      .doc(account)
      .collection('contacts')
      .doc(contact)
      .delete()
    },
    signUserUp ({dispatch, commit}, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.user.uid,
              name: null,
              email: user.user.email,
              photoURL: 'https://www.google.com/url?sa=i&rct=j&q=&esrc=s&source=images&cd=&cad=rja&uact=8&ved=2ahUKEwi9wMD3i67cAhWPJXwKHRyoA44QjRx6BAgBEAU&url=http%3A%2F%2Fbungostraydogs.wikia.com%2Fwiki%2FFile%3AProfile-icon-9.png&psig=AOvVaw2ekzAQG2fddSTWLQQ2NxGD&ust=1532190328570451',
              bio: null,
              title: null,
              organization: null,
              projects: []
            }
            var storageref = firebase.storage().ref('profile_photos/default.png')
            storageref.getDownloadURL().then(function (url) {
              newUser.photoURL = url
              dispatch('updateUser', newUser)
            }).catch(function (error) {
              console.log(error)
              return
            })
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    signUserIn ({commit}, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {
            commit('setLoading', false)
            firebase.firestore().collection('users').doc(user.user.uid).get().then(function (doc) {
              if (doc.exists) {
                commit('setUser', doc.data())
              } else {
                console.log('hello from the other side')
                return
              }
            })
            // const newUser = {
            //   id: user.uid,
            //   name: user.displayName,
            //   email: user.email,
            //   photoURL: user.photoURL,
            //   bio: ''
            // }
            // commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    signUserInGoogle ({commit, dispatch}) {
      commit('setLoading', true)
      commit('clearError')
      let provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithPopup(provider)
        .then(
          user => {
            commit('setLoading', false)
            if (user.additionalUserInfo.isNewUser) {
              const newUser = {
                id: user.user.uid,
                name: user.user.displayName,
                email: user.user.email,
                photoURL: user.user.photoURL,
                bio: null,
                title: null,
                organization: null,
                projects: []
              }
              dispatch('updateUser', newUser)
            } else {
              firebase.firestore().collection('users').doc(user.user.uid).get().then(function (doc) {
                if (doc.exists) {
                  commit('setUser', doc.data())
                } else {
                  console.log('hello from the other side')
                  return
                }
              })
            }
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    // signUserInFacebook ({commit}) {
    //   commit('setLoading', true)
    //   commit('clearError')
    //   firebase.auth().signInWithPopup(new firebase.auth.FacebookAuthProvider())
    //     .then(
    //       user => {
    //         commit('setLoading', false)
    //         const newUser = {
    //           id: user.uid,
    //           name: user.displayName,
    //           email: user.email,
    //           photoUrl: user.photoURL
    //         }
    //         commit('setUser', newUser)
    //       }
    //     )
    //     .catch(
    //       error => {
    //         commit('setLoading', false)
    //         commit('setError', error)
    //         console.log(error)
    //       }
    //     )
    // },
    // signUserInGithub ({commit}) {
    //   commit('setLoading', true)
    //   commit('clearError')
    //   firebase.auth().signInWithPopup(new firebase.auth.GithubAuthProvider())
    //     .then(
    //       user => {
    //         commit('setLoading', false)
    //         const newUser = {
    //           id: user.uid,
    //           name: user.displayName,
    //           email: user.email,
    //           photoUrl: user.photoURL
    //         }
    //         commit('setUser', newUser)
    //       }
    //     )
    //     .catch(
    //       error => {
    //         commit('setLoading', false)
    //         commit('setError', error)
    //         console.log(error)
    //       }
    //     )
    // },
    // signUserInTwitter ({commit}) {
    //   commit('setLoading', true)
    //   commit('clearError')
    //   firebase.auth().signInWithPopup(new firebase.auth.TwitterAuthProvider())
    //     .then(
    //       user => {
    //         commit('setLoading', false)
    //         const newUser = {
    //           id: user.uid,
    //           name: user.displayName,
    //           email: user.email,
    //           photoUrl: user.photoURL
    //         }
    //         commit('setUser', newUser)
    //       }
    //     )
    //     .catch(
    //       error => {
    //         commit('setLoading', false)
    //         commit('setError', error)
    //         console.log(error)
    //       }
    //     )
    // },
    autoSignIn ({commit}, payload) {
      firebase.firestore().collection('users').doc(payload.uid).get().then(function (doc) {
        if (doc.exists) {
          commit('setUser', doc.data())
        } else {
          return
        }
      })
    },
    resetPasswordWithEmail ({commit}, payload) {
      const { email } = payload
      commit('setLoading', true)
      firebase.auth().sendPasswordResetEmail(email)
      .then(
        () => {
          commit('setLoading', false)
          console.log('Email Sent')
        }
      )
      .catch(
        error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        }
      )
    },
    logout ({commit}) {
      firebase.auth().signOut()
      commit('setUser', null)
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    proj (state) {
      return state.currProj
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.js